import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createTreatmentPlan,
  getTreatmentPlans,
  updateTreatmentPlanById,
} from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import { addIcon } from "../../../util/CommonIconStyle";
import {
  answerTypes,
  petAppntTypeList,
  petTypes,
} from "../../../util/dropList";

const initObject = {
  question: "",
  questionType: "checkboxes",
  isRequired: false,
  questionId: null,
  answers: [""],
};
const requiredFields = ["planName", "species", "type"];
const initPlanValues = { type: "Outpatient" };

const TreatmentPlanCreate = ({
  setCreateVsble,
  selectedPlan,
  setSelectedPlan,
}) => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [planValues, setPlanValues] = useState(initPlanValues);
  const [planErrs, setPlanErrs] = useState({});
  const [planHlps, setPlanHlps] = useState({});
  const [questions, setQuestions] = useState([initObject]);

  useEffect(() => {
    if (!selectedPlan) return;
    getAndSetDataFromSelectedPlan();
  }, [selectedPlan]);

  const getAndSetDataFromSelectedPlan = () => {
    const planValObj = {
      ...planValues,
      planName: selectedPlan?.planName,
      species: selectedPlan?.species,
      type: selectedPlan?.type,
      description: selectedPlan?.description,
    };
    setPlanValues(planValObj);
    const reqList = selectedPlan?.treatmentPlanDetails?.map((li, i) => {
      const reqObj = {
        question: li?.question,
        questionType: li?.questionType,
        questionId: li?.questionId,
        required: li?.required,
        isRequired: li?.required,
      };
      if (
        li?.questionType === "multipleChoice" ||
        li?.questionType === "checkboxes" ||
        li?.questionType === "fileupload"
      ) {
        reqObj.answers =
          li?.questionType === "fileupload" ? ["file"] : li?.answer;
      }
      if (
        li?.questionType === "shortAnswer" ||
        li?.questionType === "paragraph"
      ) {
        reqObj.answer = "";
      }
      return reqObj;
    });
    setQuestions(reqList);
  };

  const handleChange = (name, value) => {
    setPlanValues({ ...planValues, [name]: value });
    setPlanErrs({
      ...planErrs,
      [name]:
        value?.length > 0
          ? false
          : requiredFields?.find((fld) => fld === name)
          ? true
          : false,
    });
    setPlanHlps({
      ...planHlps,
      [name]:
        value?.length > 0
          ? ""
          : requiredFields?.find((fld) => fld === name)
          ? "This field is required"
          : "",
    });
  };

  const moveArrayElement = (array, fromIndex, toIndex) => {
    const updatedArray = [...array];
    const [movedItem] = updatedArray.splice(fromIndex, 1); // Remove the item from the old index
    updatedArray.splice(toIndex, 0, movedItem); // Insert it at the new index
    return updatedArray;
  };

  const onSortEnd = (oldIndex, newIndex) => {
    setQuestions((array) => moveArrayElement(array, oldIndex, newIndex));
  };

  const handleChangeValue = (name, value, ind) => {
    const reqList = questions?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (
          value === "multipleChoice" ||
          value === "checkboxes" ||
          value === "fileupload"
        ) {
          reqObj.answers = [value === "fileupload" ? "file" : ""];
        }
        if (value === "shortAnswer" || value === "paragraph") {
          reqObj.answer = "";
        }
        return reqObj;
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleChangeAnswer = (mainInd, secInd, value) => {
    const reqList = questions?.map((li, i) => {
      if (i === mainInd) {
        const reqArr = li?.answers?.map((ans, ind) => {
          if (ind === secInd) return value;
          return ans;
        });
        return { ...li, answers: reqArr };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleAddQuestion = () => {
    setQuestions((prev) => [...prev, initObject]);
  };

  const handleDeleteQuestion = (ind) => {
    if (questions?.length > 1) {
      const reqQues = questions
        ?.filter((li) => !li?.isDelete)
        ?.reduce((acc, item, i) => {
          if (i === ind) {
            if (item?.questionId) acc.push({ ...item, isDelete: true });
          } else {
            acc.push(item);
          }
          return acc;
        }, [])
        ?.map((cl, i) => ({ ...cl, i }));
      setQuestions(reqQues);
    }
  };

  const handleBackClick = () => {
    dispatch(getTreatmentPlans());
    setPlanValues(initPlanValues);
    setCreateVsble(false);
    setSelectedPlan(null);
    setActiveStep(0);
  };

  const handleAddAnswer = (ind) => {
    const reqList = questions?.map((li, i) => {
      if (i === ind) {
        return { ...li, answers: [...li?.answers, ""] };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleDeleteAnswer = (mainInd, secInd) => {
    const reqList = questions?.map((li, i) => {
      if (i === mainInd) {
        const reqArr = li?.answers?.filter((ans, ind) => ind !== secInd);
        return { ...li, answers: reqArr };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleNext = () => {
    let errs = {};
    let hlps = {};
    requiredFields?.forEach((fld) => {
      const reqValue = planValues?.[fld];
      if (!reqValue || reqValue?.length === 0) {
        errs = { ...errs, [fld]: true };
        hlps = { ...hlps, [fld]: "This is field is required" };
      }
    });
    setPlanErrs(errs);
    setPlanHlps(hlps);
    if (Object.keys(errs)?.length > 0) return;
    if (
      questions?.length === 0 ||
      questions?.some((li) => li?.question?.length === 0 || !li?.questionType)
    )
      return;
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSubmit = () => {
    const question = questions?.map((ques) => {
      const reqObj = {
        question: ques?.question,
        questionType: ques?.questionType,
        required: ques?.isRequired,
        isDelete: ques?.isDelete ?? false,
      };
      if (
        ques?.questionType === "shortAnswer" ||
        ques?.questionType === "paragraph"
      ) {
        reqObj.answer = [ques?.answer];
      }
      if (
        ques?.questionType === "multipleChoice" ||
        ques?.questionType === "checkboxes"
      ) {
        reqObj.answer = ques?.answers;
      }
      if (ques?.questionType === "fileupload") {
        reqObj.answer = ques?.answers;
      }
      if (ques?.questionId) reqObj.questionId = ques?.questionId;
      return reqObj;
    });
    let treatmentPrescription = [];

    const data = {
      planName: planValues?.planName,
      species: planValues?.species,
      serviceType: planValues?.serviceType,
      consulationType: planValues?.consultationType,
      type: planValues?.type,
      estimatedDuration: `${planValues?.estimatedDuration ?? "1"} ${
        planValues?.type === "Outpatient" ? "mins" : "days"
      }`,
      description: planValues?.description,
      question,
      treatmentPrescription,
    };
    if (selectedPlan) {
      dispatch(
        updateTreatmentPlanById({ planId: selectedPlan?.planId, data })
      ).then((res) => {
        if (res?.payload) handleBackClick();
      });
    } else {
      dispatch(createTreatmentPlan(data)).then((res) => {
        if (res?.payload) handleBackClick();
      });
    }
  };

  return (
    <>
      <div className="ml50 cursor mt10" onClick={handleBackClick}>
        <div className="flex-row-ali-cen">
          <ArrowBackIosIcon
            sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
          />
          <Typography className="fs16 txt-semi-bold blue-color ml5">
            Back
          </Typography>
        </div>
      </div>
      <Grid container spacing={0} className="flex-center mt20">
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <div className="scroll-70vh pr10 pb30">
            {activeStep === 0 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Name <span className="red-color">*</span>
                    </div>
                    <CustomTextField
                      value={planValues?.planName}
                      handleChange={(e) =>
                        handleChange("planName", e?.target?.value)
                      }
                      fullWidth
                      error={planErrs?.planName}
                      helperText={planHlps?.planName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Species <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={petTypes}
                      value={planValues?.species ?? []}
                      handleChange={(e) =>
                        handleChange("species", e?.target?.value)
                      }
                      multiSelectTagCheck
                      error={planErrs?.species}
                      helperText={planHlps?.species}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Type <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={petAppntTypeList}
                      value={planValues?.type}
                      handleChange={(e) =>
                        handleChange("type", e?.target?.value)
                      }
                      select
                      error={planErrs?.type}
                      helperText={planHlps?.type}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Description
                    </div>
                    <CustomTextField
                      value={planValues?.description}
                      handleChange={(e) =>
                        handleChange("description", e?.target?.value)
                      }
                      fullWidth
                      multiline
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="flex-center fs24 font-medium blue-color">
                      Custom Treatment Protocol Form
                    </Typography>
                  </Grid>
                </Grid>
                <SortableList
                  onSortEnd={onSortEnd}
                  className="parent-list"
                  dragHandleSelector=".parent-drag-handle"
                  tag="div"
                >
                  {questions
                    ?.filter((li) => !li?.isDelete)
                    ?.map((ques, i) => {
                      return (
                        <SortableItem key={`${i}-parent`}>
                          <Grid container spacing={1} className="mt10">
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <Typography className="fs16 blue-color font-medium">
                                Question {i + 1}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangeValue(
                                    "question",
                                    e?.target?.value,
                                    i
                                  )
                                }
                                value={ques?.question}
                                placeholder="Type question here"
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                              <CustomSelect
                                list={answerTypes}
                                value={ques?.questionType}
                                handleChange={(e) =>
                                  handleChangeValue(
                                    "questionType",
                                    e?.target?.value,
                                    i
                                  )
                                }
                                select
                              />
                            </Grid>
                            {ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                              >
                                {ques?.answers?.map((ans, ind) => (
                                  <div className="flex-row-ali-cen">
                                    <div className="ml10">
                                      <CustomCheckbox
                                        value={false}
                                        circle={
                                          ques?.questionType ===
                                          "multipleChoice"
                                        }
                                      />
                                    </div>
                                    <div className="w60Per">
                                      <CustomTextField
                                        value={ans}
                                        fullWidth
                                        handleChange={(e) =>
                                          handleChangeAnswer(
                                            i,
                                            ind,
                                            e?.target?.value
                                          )
                                        }
                                      />
                                    </div>
                                    {ques?.answers?.length === ind + 1 ? (
                                      <img
                                        src={require("../../../assets/images/png/plusGry.png")}
                                        className="img-wh20 ml10 cursor"
                                        onClick={() => handleAddAnswer(i)}
                                      />
                                    ) : null}
                                    {ques?.answers?.length > 1 ? (
                                      <img
                                        src={require("../../../assets/images/png/delGry.png")}
                                        className="img-wh20 ml10 cursor"
                                        onClick={() =>
                                          handleDeleteAnswer(i, ind)
                                        }
                                      />
                                    ) : null}
                                  </div>
                                ))}
                              </Grid>
                            ) : null}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <div className="flex-row-between-align-center mt10">
                                <div className="flex-row-ali-cen">
                                  <div className="cursor">
                                    <span className="parent-drag-handle">
                                      ☰
                                    </span>
                                  </div>
                                  <img
                                    src={require("../../../assets/images/png/del.png")}
                                    className="img-wh20 cursor ml10"
                                    onClick={() => handleDeleteQuestion(i)}
                                  />
                                  {questions?.length - 1 === i ? (
                                    <div
                                      className="flex-row-ali-cen cursor ml10"
                                      onClick={handleAddQuestion}
                                    >
                                      <div className="flex-center plus-icon">
                                        <AddIcon sx={addIcon} />
                                      </div>
                                      <Typography className="blue-color fs16 ml5 font-bold">
                                        Add
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>
                                <div className="pr10 flex-center">
                                  <CustomSwitch
                                    value={ques?.isRequired}
                                    onChange={(e) =>
                                      handleChangeValue(
                                        "isRequired",
                                        e?.target?.value,
                                        i
                                      )
                                    }
                                    grayToBlue
                                  />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </SortableItem>
                      );
                    })}
                </SortableList>
                <div className="flex-end mt20">
                  <div>
                    <CustomButton text="Next" smallBtn onClick={handleNext} />
                  </div>
                </div>
              </div>
            ) : null}
            {activeStep === 1 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="blue-color txt-semi-bold flex-center fs20">
                      Review & Submit
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">Name</div>
                    <CustomTextField
                      value={planValues?.planName}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">Species</div>
                    <CustomSelect
                      list={petTypes}
                      value={planValues?.species ?? []}
                      multiSelectTagCheck
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">Type</div>
                    <CustomSelect
                      list={petAppntTypeList}
                      value={planValues?.type}
                      select
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Description
                    </div>
                    <CustomTextField
                      value={planValues?.description}
                      fullWidth
                      multiline
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="flex-center fs20 txt-semi-bold blue-color">
                      Custom Treatment Protocol Form
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {questions
                      ?.filter((li) => !li?.isDelete)
                      ?.map((ques, i) => (
                        <div key={`${ques?.question} ${i}`} className="mv5">
                          <Typography className="font-medium fs16 black">
                            {i + 1}) {ques?.question}
                          </Typography>
                          <div className="mv5">
                            {ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                              <div className="ml10">
                                {ques?.answers?.map((ans) => (
                                  <div className="flex-row-ali-cen">
                                    <CustomCheckbox
                                      value={false}
                                      circle={
                                        ques?.questionType === "multipleChoice"
                                      }
                                      disabled
                                    />
                                    <Typography className="mlMin15 font-medium fs14 black">
                                      {ans}
                                    </Typography>
                                  </div>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ))}
                  </Grid>
                </Grid>
                <div className="flex-end">
                  <div>
                    <CustomButton
                      text="Back"
                      smallBtn
                      grayBtn
                      onClick={handleBack}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Submit"
                      smallBtn
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default TreatmentPlanCreate;
